module.exports = __webpack_public_path__ + "img/topoAmarelo.a90a68da.png";